export default "__VITE_ASSET__CF5eODxw__"